import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import RelatedProduct from "./RelatedProduct";
import ViewReviews from "./ViewReviews";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export default function TwoTabs({descri,categ,pguid}) {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // console.log(categ,pguid);

    return (
        <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                >
                    <Tab label="Product Details" {...a11yProps(0)} />
                    {/* <Tab label="Related Products" {...a11yProps(1)} /> */}
                    <Tab label="Reviews" {...a11yProps(1)} />
                    <Tab label="Related Products" {...a11yProps(2)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                {descri}
            </CustomTabPanel>
            {/* <CustomTabPanel value={value} index={1}>
                <RelatedProduct categ={categ} pguid={pguid}/>
            </CustomTabPanel> */}
            <CustomTabPanel value={value} index={1}>
                <ViewReviews pguid={pguid}/>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                <RelatedProduct categ={categ} pguid={pguid}/>
            </CustomTabPanel>
        </Box>
    );
}
